const moduleName = "Actividad de usuario";

const READ_OTHER_USERS_ACTIVITIES = "Ver actividad de otros usuarios";

export default {
  moduleName,
  READ_OTHER_USERS_ACTIVITIES
};
